import { supportedLanguages } from '../locale.types'

export interface ICopy {
  loading: {
    description: string;
  },
  gallery: {
    title: string;
    description: string;
  },
};

export const DEFAULT_LOCALE = supportedLanguages.en

export const COPY = {
  [supportedLanguages.en]: {
    loading: {
      description: 'Slide your mouse or tap to set the cherries in motion'
    },
    gallery: {
      title: '( DISCOVER THE FULL COLLECTION )',
      description: 'Drag or click to discover the playful elegance of the fruit-forward motif.'
    },
  },
  [supportedLanguages.it]: {
    loading: {
      description: 'Muovi il mouse o tocca lo schermo per mettere in movimento le ciliegie'
    },
    gallery: {
      title: 'IT ( DISCOVER THE FULL COLLECTION ) IT',
      description: "Scopri l'eleganza giocosa del motivo con un semplice tocco."
    }
  },
  [supportedLanguages.de]: {
    loading: {
      description: 'Bewegen Sie Ihre Maus oder tippen Sie, um die Kirschen in Bewegung zu setzen'
    },
    gallery: {
      title: 'DE ( DISCOVER THE FULL COLLECTION ) DE',
      description: 'Ziehen oder klicken Sie, um die spielerische Eleganz des fruit-forward Motivs zu entdecken.'
    }
  },
  [supportedLanguages.fr]: {
    loading: {
      description: 'Faites glisser la souris ou cliquez pour animer les cerises'
    },
    gallery: {
      title: 'FR ( DISCOVER THE FULL COLLECTION ) FR',
      description: "Faites glisser ou cliquez pour découvrir l'élégance ludique de ce motif fruit-forward."
    }
  },
  [supportedLanguages.es]: {
    loading: {
      description: 'Desliza el ratón o toca para poner las cerezas en movimiento'
    },
    gallery: {
      title: 'ES ( DISCOVER THE FULL COLLECTION ) ES',
      description: 'Arrastra o haz clic para descubrir la alegre elegancia del motivo fruit-forward.'
    }
  },
  [supportedLanguages.kr]: {
    loading: {
      description: '마우스를 슬라이드하거나 탭하여 체리를 움직여 보세요.'
    },
    gallery: {
      title: 'KR ( DISCOVER THE FULL COLLECTION ) KR',
      description: '드래그하거나 클릭하여 과일의 매력적인 우아함을 발견하세요, fruit-forward 모티프의 놀이 같은 우아함을 경험해 보세요.'
    }
  },
  [supportedLanguages.jp]: {
    loading: {
      description: 'マウスをスライドさせるかタップして、さくらんぼを動かしてください。'
    },
    gallery: {
      title: 'JP ( DISCOVER THE FULL COLLECTION ) JP',
      description: 'ドラッグまたはクリックして、果実のような果実のfruit-forwardモチーフの遊び心あふれるエレガンスを発見してください。'
    }
  },
  [supportedLanguages.ch]: {
    loading: {
      description: '用您的指尖，赋予 Valentino Garavani Cherryfic 图案生命，滑动鼠标或轻触屏幕，让樱花在移动中绽放活力。'
    },
    gallery: {
      title: 'CH ( DISCOVER THE FULL COLLECTION ) CH',
      description: '拖动或点击鼠标，探索这 fruit-forward 图案的俏皮优雅。 '
    }
  },
}
